import { useFlagsQuery } from 'graphql/hooks.generated'
import { FlagsQuery } from 'graphql/types.generated'
import React, { useContext } from 'react'

export type FlagsContextModel = FlagsQuery['info']['flags']

const defaultContextValue: FlagsContextModel = {
  UNIFICACAO_BASE_ENABLED: false,
  LISTA_REGISTRO_TARDIO_NOVA_ENABLED: false,
  BUSCA_ATIVA_VACINACAO_ENABLED: false,
  OBSERVACAO_ENABLED: false,
  ASSINATURA_ELETRONICA_ENABLED: false,
  ENVIO_RAC_ENABLED: false,
  ENVIO_RPM_ENABLED: false,
  ENVIO_VACINA_ENABLED: false,
  ENVIO_RNDS_ENABLED: false,
  GARANTIA_ACESSO_CIDADAO_OBITO: false,
  CUIDADO_COMPARTILHADO_CIDADAO_OBITO_ENABLED: false,
  PILOTO_VINCULACAO_CUIDADO_ENABLED: false,
  PILOTO_COMPARTILHAMENTO_EMULTI_ENABLED: false,
  PILOTO_NOVO_CONTADOR_TEMPO_CUIDADO_ENABLED: false,
  COOKIE_ENABLED: false,
  CADASTRO_IMOVEL_ENABLED: false,
  PRESCRICAO_CONTROLADA: false,
  IMPRESSAO_ESCUTA_INICIAL_ENABLED: false,
  ATUALIZACAO_SIGTAP_ENABLED: false,
  ACOMPANHAMENTO_CONDICAO_SAUDE_ENABLED: false,
  SAUDE_INDIGENA_ENABLED: false,
  PILOTO_ALERTAS_SDC_1_ENABLED: false,
  ATIVIDADE_COLETIVA_ENABLED: false,
  RELATORIO_BOLSA_FAMILIA_ENABLED: false,
  RETIFICACAO_ATENDIMENTO_PROCEDIMENTOS_ENABLED: false,
  ULTIMOS_ACESSOS_ENABLED: false,
  PILOTO_ANEXO_ARQUIVOS_ENABLED: false,
  ANEXO_RESULTADO_EXAMES: false,
  CIDADAO_FCI_ENABLED: false,
  PILOTO_FICHA_SINAN_ENABLED: false,
  M_CHAT_ENABLED: false,
  IVCF_TERRITORIO_ENABLED: false,
  CONDUTA_SDC_ENABLED: false,
  ALERTAS_SDC_PRE_ECLAMPSIA_ENABLED: false,
  PILOTO_ESTRUTURA_GRUPO_DENGUE: false,
  PILOTO_INTEGRACAO_REGULACAO_ENABLED: false,
  PILOTO_SISTEMAS_EXTERNOS_ENABLED: false,
  PILOTO_NOTIFICACAO_LOTACAO_ENABLED: false,
  M_CHAT_RF_ENABLED: false,
  ACOMPANHAMENTO_PRE_NATAL_ENABLED: false,
  PRONTUARIO_FAMILIAR_ENABLED: false,
  PILOTO_CASA_DECIMAL_RESULTADO_EXAME_ENABLED: false,
  NOVA_ABA_ENCAMINHAMENTO_ENABLED: false,
  RENOVACAO_PRESCRICAO_ENABLED: false,
}

interface FlagsProviderProps {
  children: React.ReactNode
}

export const FlagsContext = React.createContext<FlagsContextModel>(defaultContextValue)

export function FlagsProvider({ children }: FlagsProviderProps) {
  const {
    data: { info: { flags } = {} },
  } = useFlagsQuery({
    fetchPolicy: 'cache-first',
  })

  return <FlagsContext.Provider value={flags ?? defaultContextValue}>{children}</FlagsContext.Provider>
}

export const useFlags = () => useContext(FlagsContext)
